import { h, Fragment, isValidElement } from 'preact'
import { useContext } from 'preact/compat'
import { Query, Loading } from '../context'

import { Button } from './Button.jsx'
import { Close } from './Icon.jsx'
import classnames from 'classnames'


export function FilterTags({ facets, onUpdate }) {

	const query = useContext(Query)
	const loading = useContext(Loading)

	function clearAll() {
		query.remove('search')
		query.remove('remote')
		query.remove('orderBy')
		query.remove('page')
		query.set('region', [])
		query.set('city', [])
		query.set('category', [])
		query.set('department', [])
		query.set('timeType', [])
		query.set('employmentType', [])
		onUpdate()
	}

	const classes = classnames('search-layout__tags', loading && 'loading')

	return <div class={classes}>
		<FilterTagSearch query={query} onUpdate={onUpdate} />
		<FilterTagsList facet={facets.category} onUpdate={onUpdate} />
		<FilterTagsList facet={facets.city} onUpdate={onUpdate} />
		<FilterTagsList facet={facets.region} onUpdate={onUpdate} />
		<FilterTagsBoolean facet={facets.remote} onUpdate={onUpdate} />
		<FilterTagsList facet={facets.employmentType} onUpdate={onUpdate} />
		<FilterTagsList facet={facets.timeType} onUpdate={onUpdate} />
		<Button 
			type="button" 
			class="search-layout__tags__clear" 
			variant="tag ghost" 
			size="small" 
			iconRight={Close} 
			onClick={clearAll}
		>Clear</Button>
	</div>
}


function FilterTagSearch({ query, onUpdate }) {
	const val = query.get('search')
	if (!val) return
	return <Button 
		type="button"
		size="small" 
		variant="tag" 
		iconRight={Close}
		onClick={() => {
			query.set('search', '')
			query.set('lastEdited', 'search')
			onUpdate()
		}}
	>
		{val}
	</Button>
}



function FilterTagsBoolean({ facet, onUpdate }) {

	if (!facet) return
	if (facet.type !== 'boolean' || facet.values?.TRUE?.value === undefined) return
	if (!facet.values.TRUE.selected) return
	const query = useContext(Query)

	const onClose = event => {
		query.set('lastEdited', facet.key)
		query.remove(facet.key)
		query.set('page', null)
		onUpdate()
	}

	return <Button 
		type="button"
		size="small" 
		variant="tag" 
		iconRight={Close}
		onClick={onClose}
	>
		{facet.name}
	</Button>
}


function FilterTagsList({ facet, onUpdate }) {
	if (!facet) return
	if (facet.type !== 'list') return
	const entries = Object.entries(facet.values)
	if (!entries.length) return

	const query = useContext(Query)

	const onClose = value => () => {
		query.set('lastEdited', facet.key)
		query.removeFrom(facet.key, value)
		query.set('page', null)
		onUpdate()
	}

	return entries.map(([value, facetEntry]) => {
		if (facetEntry.selected !== true) return
		return <>
			<Button 
				type="button"
				size="small" 
				variant="tag" 
				iconRight={Close}
				onClick={onClose(facetEntry.value)}
			>
			{facetEntry.value}
			</Button>
		</>
	})
}